import { useAuthContext } from 'context/auth'

export function useFeatureReminder(name: string) {
  const authContext = useAuthContext()

  return !!authContext?.user?.featureReminders?.some(reminder => reminder.attributes.name === name)
}
